import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFileSparkle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconFileSparkle"><Path d="M12 10H20V22H8.54297L8.94727 20.9473L12 19.7734V16.2266L8.94727 15.0518L7.77344 12H4.22656L4 12.5889V2H12V10Z" fill="currentColor"/><Path d="M19.4141 8H14V2.58594L19.4141 8Z" fill="currentColor"/><Path d="M6.4 14H5.6L4.6 16.6L2 17.6V18.4L4.6 19.4L5.6 22H6.4L7.4 19.4L10 18.4V17.6L7.4 16.6L6.4 14Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFileSparkle;
